import React, {useState, useEffect} from "react";
import { Tabs, Tab, Button, InputGroup } from 'react-bootstrap';
import SideBar from "../screens/Tab&Desktop/SuperAdmin/Componet/Sidebar";
import {Table,} from "react-bootstrap";
import Form from 'react-bootstrap/Form';
import { CDBSlider, CDBContainer , CDBInput} from 'cdbreact';
import { ToastContainer, toast } from 'react-toastify';
import baseUrl from "../services/api";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const FormType2 =(props) =>{
  const navigate = useNavigate();

  const location = useLocation();
  
  const session_role = sessionStorage.getItem("role");
    const [selectedOption, setSelectedOption] = useState('option1');
    const [sliderValue, setSliderValue] = useState(0);
    const handleRadioChange = (event) => {
      setSelectedOption(event.target.value);
    };
   
   const session_username = sessionStorage.getItem("name");
   const [editMode, setEditMode] = useState(false);
   const val = location.state?.data;
   const update = location.state?.anotherVariable;
   var anotherVariable = 0;
  const [isApproved, setIsApproved] = useState(true);
   const [isselled, setIsSelled] = useState(true);
   const [iscontainer, setIscontanier] = useState(true);
   const [issmall, setIssmall] = useState(true);
   const [isOrganicCoffee, setIsOrganicCoffee] = useState(editMode ? val.organiccoffee : true);
   const [ispassed, setIspassed] = useState(true);
   const [analysis, setAnalysis] = useState(editMode ? val.approvedanalysis : true);
   const [nodamage, setNoDamage] =useState(true);
   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
   useEffect(() => {
    var item_value = sessionStorage.getItem("login");
    if (item_value != "1") {
      navigate("/login");
    }
    if (location?.state?.anotherVariable) {
      setEditMode(true);
    }
   

    
  }, []);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    // Attach the event listener for window resize
    window.addEventListener('resize', handleResize);

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  useEffect(() => {
    
    if (editMode && val) {
      setFormData(val);
      console.log("chechhhjkkkkkkkkkk", val.containeridentity)
      if(val.scale){
        setSliderValue(val.scale);
      }else{
        setFormData((prevData) => ({
          ...prevData,
          scale: sliderValue, // Set to the desired value for 'Yes'
        }));
      }
      
      
      if(val.containeridentity === ""||val.containeridentity === "Yes"){
       
        setIscontanier(true);
        
        
      }else{
        setIscontanier(false);
        setFormData((prevData) => ({
          ...prevData,
          containerIdentity: val.containeridentity, // Set to the desired value for 'Yes'
        }));
      }
      if(val.sealingnumber === ""||val.sealingnumber === "Yes"){
        setIsSelled(true);
      }else{
        setIsSelled(false);
        setFormData((prevData) => ({
          ...prevData,
          sealingNumber: val.sealingnumber, // Set to the desired value for 'Yes'
        }));
      }

      if(val.organiccoffee){
        setIsOrganicCoffee(true);

      }else{
        setIsOrganicCoffee(false);
      }
      if(val.passedshippingtest){
       setIspassed(true);
      }else{
        setIspassed(false);
      }
      if(val.normalsmellandappearance === ""|| val.normalsmellandappearance === "Yes"){
      setIssmall(true);
      }else{
        setIssmall(false);
        setFormData((prevData) => ({
          ...prevData,
          normalSmellAndAppearance: val.normalsmellandappearance, // Set to the desired value for 'Yes'
        }));
      }
      if(val.approvedanalysis){
        setAnalysis(true);
      }else{
        setAnalysis(false);
      }
      if(val.nocontainerdamage === "" || val.nocontainerdamage === "Yes"){
        setNoDamage(nodamage);
      }else{
        setNoDamage(!nodamage);
        setFormData((prevData) => ({
          ...prevData,
          noContainerDamage: val.nocontainerdamage, // Set to the desired value for 'Yes'
        }));
      }
      if(val.contractnumber){
        setFormData((prevData) => ({
          ...prevData,
          contractNumber: val.contractnumber, // Set to the desired value for 'Yes'
        }));
      }
      if(val.materialcode){
        setFormData((prevData) => ({
          ...prevData,
          materialCode: val.materialcode, // Set to the desired value for 'Yes'
        }));
      }
      if(val.coffeenumber){
        setFormData((prevData) => ({
          ...prevData,
          coffeeNumber: val.coffeenumber, // Set to the desired value for 'Yes'
        }));
      }
      if(val.coffeetype){
        setFormData((prevData) => ({
          ...prevData,
         coffeeType: val.coffeetype, // Set to the desired value for 'Yes'
        }));
      }
      if(val.arrivalweight){
        setFormData((prevData) => ({
          ...prevData,
         arrivalWeight: val.arrivalweight, // Set to the desired value for 'Yes'
        }));
      }
      if(val.clearedtosilo){
        setFormData((prevData) => ({
          ...prevData,
         clearedToSilo: val.clearedtosilo, // Set to the desired value for 'Yes'
        }));
      }
      if(val.weightclearance){
        setFormData((prevData) => ({
          ...prevData,
         weightClearance: val.weightclearance, // Set to the desired value for 'Yes'
        }));
      }
      if(val.finalweight){
        setFormData((prevData) => ({
          ...prevData,
         finalWeight: val.finalweight, // Set to the desired value for 'Yes'
        }));
      }
      if(val.hinknumber){
        setFormData((prevData) => ({
          ...prevData,
         hinkNumber: val.hinknumber, // Set to the desired value for 'Yes'
        }));
      }
    }
  }, [editMode, val]);

  if (update == "1") {
    console.log("updte number ", update);
    anotherVariable = 1;
  }
   const handleCheckboxChange = (event) => {

      const { id, checked } = event.target;
  
      if (id === 'yes') {
        setNoDamage(checked);
        setFormData((prevData) => ({
          ...prevData,
          noContainerDamage: 'Yes', // Set to the desired value for 'Yes'
        }));
      } else if (id === 'no') {
        setNoDamage(!checked);
        setFormData((prevData) => ({
          ...prevData,
          noContainerDamage: 'No', // Set to the desired value for 'Yes'
        }));
      }


    // Determine which checkbox was checked and update state accordingly
    // if (id === 'yes') {
    //   setNoDamage(checked);
  
    //   if (checked) {
    //     setFormData((prevData) => ({
    //       ...prevData,
    //       noContainerDamage: 'Yes', // Set to the desired value for 'Yes'
    //     }));
    //   } else {
    //     setFormData((prevData) => ({
    //       ...prevData,
    //       noContainerDamage: '', // Set to an appropriate value for 'No'
    //     }));
    //   }
    // } else if (id === 'no') {
    //   setNoDamage(!checked);
    //   // If 'No' is selected, you might want to clear or update formData accordingly
    //   if (!checked) {
    //     setFormData((prevData) => ({
    //       ...prevData,
    //      noContainerDamage: 'No', // Set to the desired value for 'No'
    //     }));
    //   } else {
    //     setFormData((prevData) => ({
    //       ...prevData,
    //      noContainerDamage: '', // Set to an appropriate value for 'Yes'
    //     }));
    //   }
    // }
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Update the specific field in formData
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlesmall = (event) => {
      const { id, checked } = event.target;
  
    // Determine which checkbox was checked and update state accordingly
    if (id === 'smallyes') {
      setIssmall(checked);
  
      if (checked) {
        setFormData((prevData) => ({
          ...prevData,
          normalSmellAndAppearance: 'Yes', // Set to the desired value for 'Yes'
        }));
      } else {
        setFormData((prevData) => ({
          ...prevData,
          normalSmellAndAppearance: '', // Set to an appropriate value for 'No'
        }));
      }
    } else if (id === 'smallno') {
      setIssmall(!checked);
  
      // If 'No' is selected, you might want to clear or update formData accordingly
      if (!checked) {
        setFormData((prevData) => ({
          ...prevData,
          normalSmellAndAppearance: 'No', // Set to the desired value for 'No'
        }));
      } else {
        setFormData((prevData) => ({
          ...prevData,
         normalSmellAndAppearance: 'No', // Set to an appropriate value for 'Yes'
        }));
      }
    }
  };
  const handlesell = (event) => {

    const { id, checked } = event.target;
  
    // Determine which checkbox was checked and update state accordingly
    if (id === 'polyes') {
      setIsSelled(checked);
  
      if (checked) {
        setFormData((prevData) => ({
          ...prevData,
          sealingNumber: 'Yes', // Set to the desired value for 'Yes'
        }));
      } else {
        setFormData((prevData) => ({
          ...prevData,
          sealingNumber: '', // Set to an appropriate value for 'No'
        }));
      }
    } else if (id === 'polno') {
      setIsSelled(!checked);
  
      // If 'No' is selected, you might want to clear or update formData accordingly
      if (!checked) {
        setFormData((prevData) => ({
          ...prevData,
          sealingNumber: 'No', // Set to the desired value for 'No'
        }));
      } else {
        setFormData((prevData) => ({
          ...prevData,
          sealingNumber: 'No', // Set to an appropriate value for 'Yes'
        }));
      }
    }
  };
  const handlecontain = (event) => {
    const { id, checked } = event.target;
  
    // Determine which checkbox was checked and update state accordingly
    if (id === 'containyes') {
      setIscontanier(checked);
  
      if (checked) {
        setFormData((prevData) => ({
          ...prevData,
          containerIdentity: 'Yes', // Set to the desired value for 'Yes'
        }));
      } else {
        setFormData((prevData) => ({
          ...prevData,
          containerIdentity: '', // Set to an appropriate value for 'No'
        }));
      }
    } else if (id === 'contanino') {
      setIscontanier(!checked);
  
      // If 'No' is selected, you might want to clear or update formData accordingly
      if (!checked) {
        setFormData((prevData) => ({
          ...prevData,
          containerIdentity: 'No', // Set to the desired value for 'No'
        }));
      } else {
        setFormData((prevData) => ({
          ...prevData,
          containerIdentity: 'No', // Set to an appropriate value for 'Yes'
        }));
      }
    }
  };
  
  
  const handlerganic = (event) => {
    const { id, checked } = event.target;

    // Determine which checkbox was checked and update state accordingly
    if (id === 'organicyes') {
      setIsOrganicCoffee(checked);
      setFormData((prevData) => ({
        ...prevData,
        organicCoffee: true, // Set to the desired value for 'Yes'
      }));
    } else if (id === 'organicno') {
      setIsOrganicCoffee(!checked);
      setFormData((prevData) => ({
        ...prevData,
        organicCoffee: false, // Set to the desired value for 'Yes'
      }));
    }
  };
  const handleanalysis = (event) =>{
    const { id, checked } = event.target;
    if (id === 'anayes') {
      setAnalysis(checked);
      setFormData((prevData) => ({
        ...prevData,
        approvedAnalysis: true, // Set to the desired value for 'Yes'
      }));
    } else {
      setAnalysis(!checked);
      setFormData((prevData) => ({
        ...prevData,
        approvedAnalysis: false, // Set to the desired value for 'Yes'
      }));
    }
  }
  const handlerpass = (event) => {
    
    const { id, checked } = event.target;
    if (id === 'passyes') {
      setIspassed(checked);
      setFormData((prevData) => ({
        ...prevData,
        passedShippingTest: true, // Set to the desired value for 'Yes'
      }));
    } else {
      setIspassed(!checked);
      setFormData((prevData) => ({
        ...prevData,
        passedShippingTest: false, // Set to the desired value for 'Yes'
      }));
    }

    
  };
    const handleSliderChange = (event) => {
        // Assuming the event provides the new value through some property like 'value'
        const newValue = event.target.value;
        setSliderValue(newValue);

      };
      useEffect(() => {
        console.log("Scale ");
        setFormData((prevData) => ({
          ...prevData,
          scale: sliderValue,
        }));
      }, [sliderValue]);
   const [formData, setFormData] = useState({
    nameofsurveyer: session_username,
    ssa_date: '',
    relief: '',
    supplier: '',
    contractNumber: 0,
    grade: '',
    scale:  sliderValue,
    ssa_comment: '',
    materialCode: '',
    coffeeNumber: 0,
    coffeeType: '',
    organicCoffee: isOrganicCoffee,
    passedShippingTest: ispassed,
    ssa_signature: '',
    rc_date: '',
    containerIdentity: '',
    sealingNumber: '',
    noContainerDamage: '',
    normalSmellAndAppearance: '',
    arrivalWeight: 0,
    clearedToSilo: '',
    weightClearance: '',
    finalWeight: 0,
    rc_signature: '',
    hinkNumber: '',
    as_date: '',
    as_comment: '',
    approvedAnalysis: analysis,
    as_signature: '',
   });

 
 
 
   const handleAddChange = () => {
 
    axios.post(`${baseUrl}/form`, formData)
      .then(response => {
        toast.success("Form Added successfully");
        session_role=='admin'?  navigate("/member"):navigate('/form');
        
        console.log(response.data);
      })
      .catch(error => {
        toast.error("Form Not Added");
        console.error('Error saving data:', error);
      });
  };
  
  
  const handleEditChange = async () => {
    const updatedCompany = {
    nameofsurveyer: session_username,
    id:formData.id, 
    ssa_date: formData.ssa_date?formData.ssa_date:'',
    relief:  formData.relief?formData.relief:'',
    supplier: formData.supplier?formData.supplier:'',
    contractNumber:  formData.contractNumber?formData.contractNumber:0,
    grade:  formData.grade?formData.grade:'',
    scale:  sliderValue,
    ssa_comment:  formData.ssa_comment?formData.ssa_comment:'',
    materialCode: formData.materialCode?formData.materialCode:'',
    coffeeNumber:  formData.coffeeNumber?formData.coffeeNumber:0,
    coffeeType:  formData.coffeeType?formData.coffeeType:'',
    organicCoffee:  formData.organicCoffee?formData.organicCoffee:false,
    passedShippingTest:  formData.passedShippingTest?formData.passedShippingTest:false,
    ssa_signature:  formData.ssa_signature?formData.ssa_signature:'',
    rc_date:  formData.rc_date?formData.rc_date:'',
    containerIdentity:  formData.containerIdentity?formData.containerIdentity:'',
    sealingNumber:  formData.sealingNumber?formData.sealingNumber:'',
    noContainerDamage:  formData.noContainerDamage?formData.noContainerDamage:'',
    normalSmellAndAppearance:  formData.normalSmellAndAppearance?formData.normalSmellAndAppearance:'',
    arrivalWeight:  formData.arrivalWeight?formData.arrivalWeight:0,
    clearedToSilo:  formData.clearedToSilo?formData.clearedToSilo:'',
    weightClearance:  formData.weightClearance?formData.weightClearance:'',
    finalWeight:  formData.finalWeight?formData.finalWeight:0,
    rc_signature:  formData.rc_signature?formData.rc_signature:'',
    hinkNumber:  formData.hinkNumber?formData.hinkNumber:0,
    as_date:  formData.as_date?formData.as_date:'',
    as_comment:  formData.as_comment?formData.as_comment:'',
    approvedAnalysis: formData.approvedAnalysis?formData.approvedAnalysis:false,
    as_signature:  formData.as_signature?formData.as_signature:'',
    };
    console.log('update data', updatedCompany);
    await   axios
    .put(`${baseUrl}/coffeeUpdate`, updatedCompany)
    .then((response) => {
      console.log("Form updated successfully", response.data);
      toast.success("Form updated successfully");
     session_role=='admin'?  navigate("/member"):navigate('/form');
    })
    .catch((error) => {
      toast.error("Error updating Form");
      console.error("Error updating Form", error);
    });
  };

 
return(
<div class="content">
<div class="sidebar">
<SideBar/>
</div>
<div class="stuff">
    <Tabs>
   
    <Tab   eventKey="tab1" title="Blankett för mottagningskontroll">
<div style={{margin: '40px', overflow: 'auto', height: '100vh'}} class='row'>
<div class='row'>
<div class='col-md-2'><Button variant="secondary"><Link style={{textDecoration: 'none', color:'white', paddingTop: 5}} to={session_role === 'admin' ? '/member' : '/form'}>Dashboard</Link></Button> </div><hr/>
<span><label>Godkännande av Approval shipping sample</label></span>
<hr/>
<div class='col-md-3'>
 <label>Datum</label>
 <input type="date" onChange={handleInputChange} value={formData.ssa_date} name="ssa_date" class='form-control' />
</div>
<div class='col-md-3'>
 <label>Lättning</label>
 <input type="text" onChange={handleInputChange} value={formData.relief} name="relief" class='form-control' />
</div>
<div class='col-md-3'>
 <label>Leverantör</label>
 <input type="text" name="supplier" onChange={handleInputChange} value={formData.supplier} class='form-control' />
</div>
<div class='col-md-3'>
 <label>kontrakts nr</label>
 <input type="number" name="contractNumber" onChange={handleInputChange} value={formData.contractNumber} class='form-control' />
</div>
</div>
<div style={{paddingTop:'30px'}} class='row'>
<div class='col-md-3'>
 <label>Betyg</label>
 <input type="text" name='grade' onChange={handleInputChange} value={formData.grade} class='form-control' />
</div>
<div class='col-md-3'>
 <label>Skala</label>
 <CDBContainer>
      <CDBSlider
        max={5}
        min={1}
        
        value={sliderValue}
        onChange={handleSliderChange}
        style={{ width: '100%' }}
      />
    </CDBContainer>
</div>
<div class='col-md-6'>
<label>Kommentar</label>
<textarea name="ssa_comment" value={formData.ssa_comment} onChange={handleInputChange} class='form-control'></textarea>
</div>
</div>
<div style={{paddingTop:'30px'}} class='row'>
<div class='col-md-3'>
 <label>Materialkod</label>

        <input
          type="text"
          class='form-control'
          name="materialCode"
          value={formData.materialCode}
          onChange={handleInputChange}
        />
        
</div>
<div class='col-md-3'>
 <label>Kaffe nr</label>
 <input type="number" name="coffeeNumber" value={formData.coffeeNumber}  onChange={handleInputChange} class='form-control' />
</div>
<div class='col-md-3'>
 <label>Kaffe Typ</label>
 <input type="text"  name="coffeeType" value={formData.coffeeType} onChange={handleInputChange} class='form-control' />
</div>
<div class='col-md-3'>
 <label>Ekologiskt kaffe</label>
 <div className="form-control" style={{border: 'none'}}>
 <Form.Check
            inline
            label="Ja"
            name="organicCoffee"
            type='checkbox'
            id='organicyes'
            value={isOrganicCoffee}
            onChange={handlerganic}
            checked={isOrganicCoffee}
          />
          <Form.Check
            inline
            label="Nej"
            name="organicCoffee"
            type='checkbox'
            id='organicno'
            value={!isOrganicCoffee}
            onChange={handlerganic}
            checked={!isOrganicCoffee}
/> 
</div>

</div>
</div>
<div style={{paddingTop:'30px'}} class='row'>
<div class='col-md-4'>
 <label>Godkänt skeppningsprov </label>
 <div className="form-control" style={{border: 'none'}}>
      <Form.Check
            inline
            label="Ja"
            name="group1o"
            type='checkbox'
            id='passyes'
            onChange={handlerpass}
            checked={ispassed}
            
          />
          <Form.Check
            inline
            label="Nej"
            name="groupd1"
            type='checkbox'
            id='passno'
            onChange={handlerpass}
            checked={!ispassed}
            
          />
          </div>
</div>
<div class='col-md-4'>
 <label>Signatur:</label>
 <input type="text" name="ssa_signature" value={formData.ssa_signature} onChange={handleInputChange} class='form-control' />
</div>
<div class='row' style={{paddingTop:'30px'}}>
<span><label>Mottagningskontroll</label></span>
<hr/>
<div class='col-md-3'>
 <label>Datum</label>
 <input type="date" name="rc_date" value={formData.rc_date} onChange={handleInputChange} class='form-control' />
</div>
<div class='col-md-5' >
 <label>Containeridentitet</label>
 <small> (Om nej, vilket nr står på container/plomb: Stämmer:) </small>

 <div>
  <Form.Check
    inline
    label="Ja"
    name="group1"
    type="checkbox"
    id="containyes"
    onChange={handlecontain}
    checked={iscontainer}
  />
  <Form.Check
    inline
    label="Nej"
    name="group1"
    type="checkbox"
    id="contanino"
    onChange={handlecontain}
    checked={!iscontainer}
  />
  {!iscontainer && (
    <div>
      <Form.Control
        type="text"
        name="containerIdentity"
        required
        value={formData.containerIdentity}
        onChange={handleInputChange}
        placeholder="Enter details"
      />
    </div>
  )}
</div>
</div>
<div class='col-md-3' style={{}}>
 <label>Plomberingsnummer</label><br/>


<div>
<Form.Check
            inline
            label="Ja"
            name="polyes"
            type='checkbox'
            id='polyes'
            onChange={handlesell}
            checked={isselled}
          />
          <Form.Check
            inline
            label="Nej"
            name="polno"
            type='checkbox'
            id='polno'
            onChange={handlesell}
            checked={!isselled}
          />
{!isselled && (
        <div>
            <Form.Control type="text" name="sealingNumber"  value={formData.sealingNumber} onChange={handleInputChange} placeholder="Enter Sealing Number" />
     </div>
      )}
</div>
</div>
</div>
<div class='row' style={{paddingTop:'30px'}} >

<div class='col-md-3' style={{}}>
 <label>Container utan skador</label><br/>
<div class=''>
<Form.Check
            inline
            label="Ja"
            name="group1"
            type='checkbox'
            id='smallyes'
            onChange={handlesmall}
            checked = {issmall}
          />
          <Form.Check
            inline
            label="Nej"
            name="group1"
            type='checkbox'
            id='smallno'
            onChange={handlesmall}
            checked = {!issmall}
          />
{!issmall && (
        <div>
          <Form.Control type="text" name="normalSmellAndAppearance" value={formData.normalSmellAndAppearance} onChange={handleInputChange} placeholder="Enter details" />
        </div>
      )}
</div>
</div>
<div class='col-md-3'>
 <label>Normal lukt och utseende</label><br/>
<div >
<Form.Check
            inline
            label="Ja"
            name="group1"
            type='checkbox'
            id='yes'
            onChange={handleCheckboxChange}
            checked={nodamage}
          />
          <Form.Check
            inline
            label="Nej"
            name="group1"
            type='checkbox'
            id='no'
            onChange={handleCheckboxChange}
            checked={!nodamage}
          />
{!nodamage && (
        <div>
          <Form.Control type="text" name="noContainerDamage" value={formData.noContainerDamage} onChange={handleInputChange} placeholder="Enter details" />
        
         
        </div>
      )}
</div>
</div>
<div class='col-md-3'>
<label>Ankomstvikt</label>
<InputGroup >
<input type="number" name="arrivalWeight" value={formData.arrivalWeight} onChange={handleInputChange} class='form-control' />
<select class='select'>
    <option>KG</option>
</select>
</InputGroup>
</div>
<div class='col-md-3'>
<label>Rensas till silo</label>
<input type="text" name="clearedToSilo" value={formData.clearedToSilo} onChange={handleInputChange} class='form-control' />
</div>

</div>

<div class='row' style={{paddingTop:'30px'}} >
<div class='col-md-3'>
<label>Vikt rensning</label>
<input type="text" name="weightClearance" value={formData.weightClearance} onChange={handleInputChange} class='form-control'/>
</div>
<div class='col-md-3'>
<label>Slutvikt</label>
<InputGroup >
<input type="number" name="finalWeight" value={formData.finalWeight} onChange={handleInputChange} class='form-control' />
<select class='select'>
    <option>KG</option>
  
</select>
</InputGroup>
</div>
<div class='col-md-3'>
<label>
  Signatur</label>
<input type="text" name="rc_signature" value={formData.rc_signature} onChange={handleInputChange} class='form-control'/>
</div>
<div class='col-md-3'>
<label>Hinknummer</label>
<input type="text" name="hinkNumber" value={formData.hinkNumber} onChange={handleInputChange} class='form-control'/>
</div>
</div>
<div class='row' style={{paddingTop:'30px'}} >
<span><label>Analys av prover</label></span>
<hr/>
<div class='col-md-3'>
 <label>Datum</label>
 <input type="date" name="as_date" value={formData.as_date} onChange={handleInputChange} class='form-control' />
</div>
<div class='col-md-3'>
<label>Kommentar</label>
<textarea name="as_comment" value={formData.as_comment} class='form-control' onChange={handleInputChange}></textarea>
</div>

<div class='col-md-3'> 
<label>
Godkänd analys 
</label>
<div>
<Form.Check
inline
label="Ja"
name="anayes"
type='checkbox'
id='anayes'
onChange={handleanalysis}
checked={analysis}
/>
<Form.Check
inline
label="Nej"
name="anano"
type='checkbox'
id='anano'
onChange={handleanalysis}
checked={!analysis}
/>
</div>
</div>
<div class='col-md-3'> 

<label>Signatur</label>
<input type="text" name="as_signature" value={formData.as_signature} onChange={handleInputChange} class='form-control'/>
</div>
</div>
{editMode ?
<>

  <Button onClick={handleEditChange} style={{width: '200px', marginTop: '10px', marginLeft:'30px'}} >Update</Button>
</>
:
<Button onClick={handleAddChange} style={{width: '200px', marginTop: '10px', marginLeft:'30px'}} >Save</Button>

}
</div>
</div>
    </Tab>
    <Tab   eventKey="tab2" title="Betygskala">

<div style={{margin: '30px', overflow: 'auto', maxWidth: windowWidth <= 600 ? '100vh' : '',}} class='row'>
<Table striped bordered hover>
    <thead>
        <tr>
        <th>Företags name</th>
        <th>Råvaruspecifikation
Betygskala för råkaffe</th>
        <th colSpan={4}>Giltig
från:2006-04-04
Utgåva:1</th>
                <th></th>
</tr>
<td></td>
    </thead>
</Table>
<div class='row'>

<p>Betygskala för bedömning av råkaffe.
Varje kaffe bedöms mot andra kaffen av samma ursprung. Man kan inte bedöma olika
ursprung mot varandra.</p><br/>
<p>Grade 1-2</p><br/>
<p>Kaffet blir underkänt och nytt prov begärs från leverantör. Om ett kaffe får tbetyg 1 eller 2 vid
mottagningskontrollen får det ej användas i produktionen utan att ytterligare analyser görs och
bedöms.</p>
<br/>
<p>Betyg 3</p>
<br />
<p>Kaffet är godkänt</p>
<br />
<p>Betyg 4-5</p> <br/>
<p>Kaffet är över medel samt utomordentligt.</p>
<br />
<Table striped bordered hover >
<thead>
    <tr>
    <th>Betyg</th>
    <th>Tvättad Arabica</th>
    <th colSpan={4}>Otvättad Arabica Robusta</th>
    
    </tr>
</thead>
<tbody>
    <tr>
        <td>1</td>
        <td>Gammal smak
Smak eller lukt av mögel
Smak eller lukt av
kemiska ämnen
Fel råkaffe mot vad som
är beställt</td>
<td colSpan={4}>
Gammal smak

Gammal smak

Smak eller lukt av

Smak eller lukt av mögel

mögel
</td>
<td>
Smak eller lukt av kemiska

Smak eller lukt av

ämnen

kemiska ämnen

Fel råkaffe mot vad som är

Fel råkaffe mot vad

beställt

som är beställt</td>
    </tr>
    <tr>
        <td>2</td>
        <td>Stor förekomst av trasiga
bönor Fel storlek, (screen)
”Stinkers” i minst 1 av 6 koppar</td>
        <td colSpan={4}>Stor förekomst av

Stor förekomst av trasiga bönor.

trasiga bönor

Oacceptabel smak tränger

Fel storlek, (screen)

igenom i koppen på ett malet

Minst 2 koppar har

och blandat prov på 50g.

anmärkning</td>
<td>Stor förekomst av trasiga bönor.
Oacceptabel smak tränger
penetrates through the
igenom i koppen på ett malet
och blandat prov på 50g.</td>
    </tr>
    <tr>
        <td>3</td>
        <td>Ingen dålig kopp får
förekomma. Ren smak och
lukt, inga
bismaker som ej hör kaffe till
får finnas. Råkaffet skall vara
helt och ha en jämn färg.</td>
        <td colSpan={4}>Max 1 av 6 koppar får
ha en anmärkning.
Dock ingen av de som
nämns i betyg 1.</td>
        <td>Ett malet och blandat prov på
50g skall ge en kopp där ingen
give a cup where non
oacceptabel smak tränger
igenom.</td>
    </tr>
    <tr>
        <td>4</td>
        <td>All grade 3 criterion must be met
The coffee adds something extra
e.g. high degree of sweetness,
acid, body</td>
        <td colSpan={4}>helt och ha en jämn färg.
Utöver kriterierna för betyg
3 krävs:
Kaffet tillför något extra
t.ex. hög grad sötma, syra,
body</td>
        <td>Max 1 av 6 koppar får ha en
        anmärkning. Dock ingen av de
        som nämns i betyg 1.</td>
    </tr>
    <tr>
        <td>5</td>
        <td>Utöver kriterierna för betyg
4 krväs:
Kaffet skall vara utomordentligt.</td>
        <td colSpan={4}>
        betyg 4 krväs:
        Kaffet tillför något
        extra t.ex. hög grad
        sötma, syra, body.</td>
            <td>Ingen dålig kopp får förekomma.
            Ren smak och lukt, inga
            bismaker som ej hör kaffe till får
            finnas. Råkaffet skall vara helt och ha en jämn färg.</td>
        
    </tr>
</tbody>

</Table>
</div>
</div>
    </Tab>
    </Tabs>
</div>
</div>
);

}
export default FormType2;